'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { defaultLanguage } from '@stereoagency/constants';
import { articleByIdQuery } from './articleByIdQuery';
import ArticlePage from './ArticlePage.client';
import { PageSections } from '@/components/layout';
import { findInKeyArray } from '@/utils';

interface Props {
  id: string;
  lang: string;
}

export default function DraftModeArticlePage({ id, lang }: Props) {
  const [data] = useLiveQuery<(typeof articleByIdQuery)[1] | null>(
    null,
    articleByIdQuery[0],
    { id }
  );

  if (data == null) {
    return null;
  }

  const content = data.content
    ? findInKeyArray(data.content, [lang, defaultLanguage.id])
    : null;

  return (
    <ArticlePage
      lang={lang}
      article={{ ...data, relatedArticles: [] }}
      content={
        content?.value ? (
          <PageSections isPreview sections={content?.value ?? []} />
        ) : null
      }
    />
  );
}
